import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/pages/solution/ui/solution-page.tsx");
